export enum ContentManagerHomeEnum {
    Pinned,
    Recent,
    Shared,
    None
  }